class Controller {
  constructor($injector, $stateParams, Sections) {
    this.$injector = $injector;
    this.Events = this.$injector.get("Events");
    this.$stateParams = $stateParams;

    this.activeParams = this.$stateParams;
    this.sections = Sections.settingsSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;

    this.addItemEvent = this.Events.getAddEvent("pricing");
    this.filterEvent = this.Events.getFilterEvent("pricing");
    this.paginateEvent = this.Events.getPaginateEvent("pricing");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/pricings/pricings.controller.js